import { createFileRoute } from '@tanstack/react-router'

import { ThemeSettingsPage } from '@/pages/settings/theme/ThemeSettingsPage'

export const Route = createFileRoute('/_authenticated/settings/theme')({
  component: ThemeSettingsPage,
})
